var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg666(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    x: 0,
    y: 0,
    viewBox: "0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.849 18.528H77.834V74.512H21.849z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M101.693 18.528H157.677V74.513H101.693z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.849 99.871H77.834V155.85399999999998H21.849z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M101.693 99.87H157.677V155.854H101.693z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M182.448 18.773H238.431V74.758H182.448z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M262.287 18.773H318.274V74.758H262.287z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M182.448 100.116H238.431V156.099H182.448z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M262.287 100.116H318.274V156.1H262.287z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.849 181.456H77.834V237.44199999999998H21.849z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M101.693 181.456H157.677V237.44199999999998H101.693z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.849 262.799H77.834V318.78299999999996H21.849z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M101.693 262.801H157.677V318.784H101.693z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M182.448 181.456H238.431V237.44099999999997H182.448z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M262.287 181.455H318.274V237.442H262.287z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M182.448 262.798H238.431V318.783H182.448z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M262.287 262.8H318.274V318.783H262.287z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M341.476 18.774H397.461V74.759H341.476z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M341.476 100.117H397.461V156.101H341.476z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M341.476 181.456H397.461V237.44199999999998H341.476z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M341.476 262.801H397.461V318.784H341.476z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M21.979 344.143H77.963V400.12699999999995H21.979z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M101.822 344.143H157.806V400.12699999999995H101.822z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M182.577 344.143H238.561V400.12699999999995H182.577z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M262.416 344.142H318.403V400.126H262.416z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M341.604 344.143H397.591V400.12699999999995H341.604z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M421.445 18.773H477.432V74.757H421.445z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M422.164 100.115H478.151V156.099H422.164z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M422.164 181.456H478.151V237.44199999999998H422.164z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M422.164 262.799H478.151V318.782H422.164z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M421.575 344.14H477.562V400.12399999999997H421.575z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M22.569 425.488H78.553V481.472H22.569z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M102.411 425.49H158.39600000000002V481.471H102.411z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M182.512 425.488H238.496V481.472H182.512z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M262.352 425.49H318.339V481.471H262.352z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M342.195 425.49H398.18V481.471H342.195z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M422.164 425.488H478.151V481.472H422.164z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg666);
export default __webpack_public_path__ + "static/media/666.45f565c163d359dff7f6f86707101367.svg";
export { ForwardRef as ReactComponent };